module.exports = __webpack_public_path__ + "static/media/Person2.2119300b.png";